import React from "react";
import { setInfoKey } from '../../api/information-collection/actions'
import moment from 'moment'

class StartDateOptions extends React.Component {
    constructor(props) {
        super(props)
        const initialState = this.initialStateFromProps(props)
        this.state = initialState
    }

    initialStateFromProps(props) {
        let StartDateOptions = [];
        StartDateOptions.push(moment(props.startDate, 'D.M.YYYY'))
        StartDateOptions.push(moment(props.startDate, 'D.M.YYYY').add(1, 'months').startOf('date'))
        StartDateOptions.push(moment(props.startDate, 'D.M.YYYY').add(2, 'months').startOf('date'))
        StartDateOptions.push(moment(props.startDate, 'D.M.YYYY').add(3, 'months').startOf('date'))

        return {
            initalStartingDate: props.startDate,
            StartDateOptions,
        }
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (!this.state.updated && props.startDate !== this.state.initalStartingDate) {
          const newState = this.initialStateFromProps(props);
          this.setState({ ...newState, updated: true });
        }
    }

    onChange(e) {
        const { dispatch, contractDateKey, customerId } = this.props;
        dispatch(setInfoKey({key: contractDateKey, value: e.target.value }, customerId))
    }


    render() {
        const { disabled } = this.props;
        const { StartDateOptions } = this.state;
        return (
            <select className="custom-select col-12 col-sm-6" disabled={disabled} onChange={this.onChange.bind(this)} value={this.props.selectedDate}>
                {StartDateOptions.map(date =>
                    <option key={date} value={date.format('D.M.YYYY')}>{date.format('D.M.YYYY')}</option>
                )}
            </select>
        )
    }
}

export default StartDateOptions